import { render, staticRenderFns } from "./EnterTemplate.vue?vue&type=template&id=164efc30"
import script from "./EnterTemplate.vue?vue&type=script&lang=ts"
export * from "./EnterTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports